
/**
 * lineage2common Data 관리 클래스
 * @category lineage2common
 * @memberof module:lineage2common
 * @param  {Object} _config={} 설정
 */
class DataStore {
    constructor(_config={}){
        this.data = {
            config: _config,
        };

        this.apiUrlList = {
            CharacterInfo: this.data.config.apiDomain + '/main/character', // 대표캐릭터 정보
            BossCharacter: this.data.config.apiDomain + '/boss-character', // 대표캐릭터
            CharacterList: this.data.config.apiDomain + '/my/characters', // 내 보유 캐릭터목록
        };
    }

    /**
     * @param  {String} _key='subsub'  요청할 데이터의 키네임
     * @param  {Object} _param={} 요청시 추가할 파라미터 데이터
     * @param  {Function} _callback=()=>{} 요청 완료후 데이터 전달할 콜백 함수...
     * @category lineage2common
     * @returns {Object} Json 데이타
     * @example
     * const appConfig = getData('sub1', {page: 1,per_page: 12}, this.render.bind(this));
     */
    getData(_key = '', _param={}, _callback = ()=>{}){
        if( this.data[_key] ){
            _callback(this.data[_key]);
            return this.data[_key];
        }else{
            axios.get(this.apiUrlList[_key], {
                params: _param,
                withCredentials: true
            })
            .then( (response) => {
                this.data[_key] = response.data;
                _callback(response.data);
                return response.data;
            })
            .catch( (error, d) => {
                console.log(_key, error,'----', d);
            })
            .then( (d) => {
            }); 
        }
    }

    changeBossChar(_serverId=0, _charId=0, _callback = ()=>{}){
        axios({
            method: 'PUT',
            url: this.apiUrlList.BossCharacter,
            withCredentials: true,
            data: {
                serverId: _serverId,
                characterId: _charId
            }
        })
        .then( (response) => {
            _callback(response.data);
        })
        .catch( (error, d) => {
            console.log('changeBossChar', error,'----', d);
        })
        .then( (d) => {
        }); 
    }

} // end of class
export default DataStore;